import { createContext, useContext } from 'react'

export const AppContext = createContext({
  currentLanguage: 'de',
  chat: null,
  setChat: (chat) => {},
})

export const useAppContext = () => useContext(AppContext)
